export default __webpack_public_path__ + "static/media/StoryPlaza.b741056a.svg";